import { useAppConfiguration, useGraphqlMutation } from '@mews-commander/data-access';
import { graphql } from '@mews-commander/guest-profile';

const DeleteIdentityDocumentPhotoMutation = graphql(`
    mutation deleteIdentityDocumentPhoto($id: UUID!, $identityDocumentId: UUID!, $guestId: UUID!) {
        deleteIdentityDocumentPhoto(id: $id, identityDocumentId: $identityDocumentId, guestId: $guestId) {
            success
        }
    }
`);

export const useDeleteIdentityDocumentPhotoMutation = () => {
    const { guestProfileApiUrl } = useAppConfiguration();

    return useGraphqlMutation(guestProfileApiUrl, {
        document: DeleteIdentityDocumentPhotoMutation,
    });
};
